// ✅ FormRadio.jsx
import React from "react";

const FormRadio = (
    { field, value, handleChange, disabled = false, ...props }) => {

    const isChecked = value === field.value;

    const handleRadioChange = (e) => {
        handleChange({
            target: {
                name: field.name,
                value: e.target.value
            },
        });
    };

    return (
        <div  className={field.fieldSize || "col-auto"}>
            <div className={`form-check ${field.inline ? "form-check-inline" : ""}`}>
                <input
                    className="form-check-input"
                    type="radio"
                    id={field.id || `${field.name}-${field.value}`}
                    name={field.name}
                    value={field.value}
                    checked={isChecked}
                    disabled={disabled || field.disabled}
                    onChange={handleRadioChange}
                />

                <label
                    className="form-check-label"
                    htmlFor={field.id || `${field.name}-${field.value}`}
                >
                    {field.label}
                </label>
            </div>
        </div>
    );
};

export default FormRadio;
